import { IAnalyticsV2Filters } from "./IAnalyticsFilters";

export enum AnalyticsPageTabs {
  AppUsage = "AppUsage",
  HostAndDevices = "HostAndDevices",
  Capability = "Capability",
  Segment = "Segment",
  Vertical = "Vertical",
}

export enum AnalyticsV2WidgetLoadingState {
  NotLoaded = "NotLoaded",
  Refreshing = "Refreshing",
  Loading = "Loading",
  Error = "Error",
  Loaded = "Loaded",
}

export enum AnalyticsV2Interval {
  Daily = "Daily",
  Monthly = "Monthly",
  Weekly = "Weekly",
}

export enum AnalyticsV2WidgetSize {
  Small = "Small",
  Medium = "Medium",
  Large = "Large",
}

export interface IWidgetBase {
  status: AnalyticsV2WidgetLoadingState;
  filter: IAnalyticsV2Filters;
}

